import * as React from "react";
import styled from "styled-components";

import { DateTime } from "luxon";

import { IconChevron, Text } from "../../../../components/atoms";
import { theme } from "../../../../theme";

interface IProps {
  firstMonth: boolean;
  lastMonth: boolean;
  onMonthLeft(): void;
  onMonthRight(): void;
  selectedMonth: DateTime;
}

interface IArrows {
  isDisabled: boolean;
}

const DatePickerMonthSelectorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.size16} 0`};
`;

const DatePickerMonthSelectorLeft = styled.div`
  display: inline-flex;
  align-items: center;

  > * {
    display: inline-flex;
  }
`;

const DatePickerMonthSelectorIconRight = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  ${(props: IArrows) =>
    props.isDisabled &&
    `
  cursor: default;
  svg {
    fill: ${theme.color.borderColor}
  }`};
`;

const DatePickerMonthSelectorIconLeft = styled(
  DatePickerMonthSelectorIconRight,
)`
  transform: rotate(180deg);
`;

const DatePickerMonthText = styled(Text)`
  font-family: ${({ theme }) => theme.type.fonts.main};
  font-size: ${({ theme }) => theme.type.sizes.size16};
  color: ${theme.color.ruubyGreyDark};
  user-select: none;
  padding-bottom: 2px;
`;

const DatePickerMonthSelector: React.FC<IProps> = (props) => {
  return (
    <DatePickerMonthSelectorWrapper>
      <DatePickerMonthSelectorLeft>
        <DatePickerMonthSelectorIconLeft
          onClick={!props.firstMonth ? props.onMonthLeft : undefined}
          isDisabled={props.firstMonth}
        >
          <IconChevron />
        </DatePickerMonthSelectorIconLeft>
        <DatePickerMonthText size="18">
          {props.selectedMonth.toFormat("MMMM")}{" "}
          {props.selectedMonth.toFormat("y")}
        </DatePickerMonthText>
      </DatePickerMonthSelectorLeft>
      <DatePickerMonthSelectorIconRight
        onClick={!props.lastMonth ? props.onMonthRight : undefined}
        isDisabled={props.lastMonth}
      >
        <IconChevron />
      </DatePickerMonthSelectorIconRight>
    </DatePickerMonthSelectorWrapper>
  );
};

export { DatePickerMonthSelector };
